module.exports = __webpack_public_path__ + "static/media/help.6aff03ec.svg";